export default __webpack_public_path__ + "static/media/file3.a161419d.png";